
import { useState, useContext, useEffect } from 'react';
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import DireccionContext from "context/DireccionContext";
import ErrorMessage from 'components/ErrorMessage';

const DIRECCION_VALUES = {
    alias: '',
    barrio: '',
    codCiudad: '',
    codDepartamento: '',
    direccion: '',
    direccionID: '',
    esDireccionPredeterminada: false,
    observacion: '',
    tipoDireccionID: false,
    calle: '',
    carrera: '',
    numero: '',
    tipoInmueble: '',
    numeroTipoInmueble: '',
    bloqueInterior: '',
    numeroBloqueInterior: '',
    codigoDireccionMER: '',
    tipoDireccionMER: ''

}

function Form({ createDireccion, updateDireccion, setIsSearched}) {
    const { direccion: selectedDireccion, setDireccion: setSelectedDireccion, message, setMessage } = useContext(DireccionContext);

    const [form, setForm] = useState(DIRECCION_VALUES);

    const { alias, barrio, codCiudad, codDepartamento, direccion, direccionID, esDireccionPredeterminada, observacion, tipoDireccionID, calle, carrera, numero, tipoInmueble, numeroTipoInmueble, bloqueInterior, numeroBloqueInterior, codigoDireccionMER, tipoDireccionMER} = form;


    let myAbi = HelpAbility();
    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    }

    const handleChangeBool = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value === 'true' });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let status = Object.keys(selectedDireccion).length ? await updateDireccion({ direccion: form, id: selectedDireccion._id }) : await createDireccion({ direccion: form })
        if (!status) {
            setIsSearched({
                search: '',
                option: '',
                state: false
            })
            setForm(DIRECCION_VALUES)
            setSelectedDireccion({});
            setMessage({ message: '', status: 200 })
        }
    }

    const handleReset = () => {
        setForm(DIRECCION_VALUES)
        setSelectedDireccion({});
        setMessage({ message: '', status: 200 })
    }


    const isVisibleForm = Object.keys(selectedDireccion).length ? myAbi.has(C.A.DIRECTION.UPDATE) : myAbi.has(C.A.DIRECTION.CREATE);

    useEffect(() => {
        if (!Object.keys(selectedDireccion).length) return null;
        setForm(selectedDireccion)
        // eslint-disable-next-line
    }, [selectedDireccion])

    return (
        <>
            {isVisibleForm
                &&

                <div className="mt-4">
                    <div className="row mb-2">
                        <h6>{Object.keys(selectedDireccion).length ? 'Editar' : 'Agregar'} Direccion</h6>
                    </div>
                    {message.status !== 200 && message.message && <ErrorMessage message={message.message}></ErrorMessage>}
                    <div className="rounded-3 p-3"
                        style={{ border: '1px solid black', paddingTop: '15px' }}>
                        <div className="d-flex justify-content-center">
                            <div className="col-3 themed-grid-col" style={{ paddingRight: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="alias" className="form-label">Alias *</label>
                                    <input type="text" className="form-control" id="alias"
                                        name="alias" autoComplete="off" value={alias} onChange={handleChange} placeholder="Ej. Signum" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="barrio" className="form-label">Barrio *</label>
                                    <input type="text" className="form-control" id="barrio" name="barrio" autoComplete="off"
                                        value={barrio} onChange={handleChange} placeholder="Ej. dep boyaca city bonza" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="codCiudad" className="form-label">codCiudad *</label>
                                    <input type="text" className="form-control" id="codCiudad" name="codCiudad" autoComplete="off"
                                        value={codCiudad} onChange={handleChange} placeholder="Ej. 1625" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="codDepartamento" className="form-label">codDepartamento *</label>
                                    <input type="text" className="form-control" id="codDepartamento" name="codDepartamento" autoComplete="off"
                                        value={codDepartamento} onChange={handleChange} placeholder="Ej. BOYACA" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="direccion" className="form-label">Direccion *</label>
                                    <input type="text" className="form-control" id="direccion" name="direccion" autoComplete="off"
                                        value={direccion} onChange={handleChange} placeholder="Ej. Las flores 2" />
                                </div>
                            </div>

                            <div className="col-3 themed-grid-col" style={{ paddingLeft: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="direccionID" className="form-label">DireccionID *</label>
                                    <input type="text" className="form-control" id="direccionID" name="direccionID" autoComplete="off"
                                        value={direccionID} onChange={handleChange} placeholder="Ej. 16837" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="statusDepartamen" className="form-label">Es Dirección Predeterminada *</label>
                                    <div className="row mb-3">
                                        <div className="col">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="esDireccionPredeterminada"
                                                    checked={esDireccionPredeterminada === true} id="isVisible-radio-true"
                                                    value={true} onChange={handleChangeBool} />
                                                <label className="form-check-label" htmlFor="isVisible-radio-true">Si</label>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="esDireccionPredeterminada"
                                                    checked={esDireccionPredeterminada === false} id="isVisible-radio-false"
                                                    value={false} onChange={handleChangeBool} />
                                                <label className="form-check-label" htmlFor="isVisible-radio-false">No</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="observacion" className="form-label">Observación</label>
                                    <input type="text" className="form-control" id="observacion" name="observacion"
                                        autoComplete="off" value={observacion} onChange={handleChange} placeholder="Ej. Los girasoles" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="statusDepartamen" className="form-label">TipoDireccionID *</label>
                                    <div className="row mb-3">
                                        <div className="col">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="tipoDireccionID"
                                                    checked={tipoDireccionID === true} id="isVisible-radio-true"
                                                    value={true} onChange={handleChangeBool} />
                                                <label className="form-check-label" htmlFor="isVisible-radio-true">1</label>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="tipoDireccionID"
                                                    checked={tipoDireccionID === false} id="isVisible-radio-false"
                                                    value={false} onChange={handleChangeBool} />
                                                <label className="form-check-label" htmlFor="isVisible-radio-false">0</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="calle" className="form-label">Calle</label>
                                    <input type="text" className="form-control" id="calle" name="calle"
                                        autoComplete="off" value={calle} onChange={handleChange} />
                                </div>
                            </div>

                            <div className="col-3 themed-grid-col" style={{ paddingLeft: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="carrera" className="form-label">Carrera</label>
                                    <input type="text" className="form-control" id="carrera" name="carrera"
                                        autoComplete="off" value={carrera} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="numero" className="form-label">Numero</label>
                                    <input type="text" className="form-control" id="numero" name="numero"
                                        autoComplete="off" value={numero} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="tipoInmueble" className="form-label">TipoInmueble</label>
                                    <input type="text" className="form-control" id="tipoInmueble" name="tipoInmueble"
                                        autoComplete="off" value={tipoInmueble} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="numeroTipoInmueble" className="form-label">NumeroTipoInmueble</label>
                                    <input type="text" className="form-control" id="numeroTipoInmueble" name="numeroTipoInmueble"
                                        autoComplete="off" value={numeroTipoInmueble} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="bloqueInterior" className="form-label">BloqueInterior</label>
                                    <input type="text" className="form-control" id="bloqueInterior" name="bloqueInterior"
                                        autoComplete="off" value={bloqueInterior} onChange={handleChange} />
                                </div>
                              
                            </div>


                            <div className="col-3 themed-grid-col ms-2" style={{ paddingLeft: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="numeroBloqueInterior" className="form-label">NumeroBloqueInterior</label>
                                    <input type="text" className="form-control" id="numeroBloqueInterior" name="numeroBloqueInterior"
                                        autoComplete="off" value={numeroBloqueInterior} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="codigoDireccionMER" className="form-label">CodigoDireccionMER</label>
                                    <input type="text" className="form-control" id="codigoDireccionMER" name="codigoDireccionMER"
                                        autoComplete="off" value={codigoDireccionMER} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="tipoDireccionMER" className="form-label">TipoDireccionMER</label>
                                    <input type="text" className="form-control" id="tipoDireccionMER" name="tipoDireccionMER"
                                        autoComplete="off" value={tipoDireccionMER} onChange={handleChange} />
                                </div>
                                <button className={'d-block d-block w-100 mb-2 btn btn-' + (true ? 'success' : 'primary')} type="submit"
                                    onClick={handleSubmit}><i
                                        className="bi bi-save" />{Object.keys(selectedDireccion).length ? 'Actualizar' : 'Guardar'}</button>
                                <button type="reset" className="d-block w-100 btn btn-secondary" onClick={handleReset}><i
                                    className="bi bi-eraser" /> Limpiar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default Form
